import { action } from 'satcheljs';
export default action('GET_FOLDER_DATA', function (folderId) {
    return {
        folderId: folderId,
    };
});
//# sourceMappingURL=getFolderData.js.map